var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 d-flex align-center",staticStyle:{"height":"72px","justify-content":"center"}},[_c('v-progress-circular',{attrs:{"size":"25","width":"2","indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }